let localStorage = require('local-storage')
import Config from './app.config'
import Cookies from 'js-cookie'

/**
 * 获取存储的用户信息
 * @returns {*}
 */
export function getUserInfo() {
    if (Config.storageType === 1) {
        return Cookies.get(Config.userInfoKey)
    }
    return localStorage.get(Config.userInfoKey);
}

/**
 * 存储用户信息
 * @param user
 * @returns {*}
 */
export function setUserInfo(user) {
    if (Config.storageType === 1) {
        Cookies.set(Config.userInfoKey, user)
        return
    }
    localStorage.set(Config.userInfoKey, user)
    return user;
}

/**
 * 删除用户信息
 * @returns {*}
 */
export function removeUserInfo() {
    if (Config.storageType === 1) {
        Cookies.remove(Config.userInfoKey);
        return
    }
    return localStorage.remove(Config.userInfoKey)
}

/**
 * 获取token
 * @returns {*}
 */
export function getToken() {
    if (Config.storageType === 1) {
        return  Cookies.get(Config.tokenKey);
    }
    return localStorage.get(Config.tokenKey)
}

/**
 * 存储token
 * @param token
 * @returns {*}
 */
export function setToken(token) {
    if (Config.storageType === 1) {
        Cookies.set(Config.tokenKey, token);
        return
    }
    return localStorage.set(Config.tokenKey, token)
}

/**
 * 删除token
 * @returns {*}
 */
export function removeToken() {
    if (Config.storageType === 1) {
        Cookies.remove(Config.tokenKey);
        return
    }
    return localStorage.remove(Config.tokenKey)
}

/**
 * 检测是否登录
 * @returns {boolean} true = 已登录，false = 未登录
 */
export function isLogin() {
    return (getToken() || '').length > 5
}

export default {
    getUserInfo,
    setUserInfo,
    getToken,
    setToken,
    removeToken,
    removeUserInfo,
    isLogin
}
